import { useState } from 'react';

import {
  Anchor,
  CloseIcon,
  Flex,
  IconButton,
  ToastMessage,
} from '@hcs/design-system';

import { useLatestReleaseVersion } from '../../hooks/useLatestReleaseVersion';

const dataHcName = 'release-version-checker';
export const ReleaseVersionChecker = () => {
  const [isOutdated, setIsOutdated] = useState(false);
  const [isOutdatedAck, setIsOutdatedAck] = useState(false);
  const [previousLatestReleaseVersion, setPreviousLatestReleaseVersion] =
    useState<string | null>(null);
  const { data: latestReleaseVersion, isFetching } = useLatestReleaseVersion();

  // we want to show the notification every time the call happens (even if the user has dismissed)
  // expectation is call will get stale after 5 minutes and a window refocus will trigger a refetch
  if (isFetching) {
    if (isOutdatedAck === true) {
      setIsOutdatedAck(false);
    }
  }

  if (
    latestReleaseVersion &&
    latestReleaseVersion !== previousLatestReleaseVersion
  ) {
    const isOutdatedNow = latestReleaseVersion !== window.RELEASE;
    if (isOutdatedNow !== isOutdated) {
      setIsOutdated(isOutdatedNow);
      setIsOutdatedAck(false);
    }
    setPreviousLatestReleaseVersion(latestReleaseVersion);
  }

  const reloadApp = () => {
    window.location.reload(); // Force a hard reload
  };

  if (isOutdated && !isOutdatedAck) {
    return (
      <ToastMessage
        toast={{
          type: 'info',
          title: (
            <Flex direction="row" gap="10px" justifyContent="space-between">
              <div>
                <div>An app update is available.</div>
                <div>
                  <Anchor
                    dataHcName={`${dataHcName}-reload`}
                    onClick={reloadApp}
                  >
                    Click here to refresh
                  </Anchor>
                </div>
              </div>
              <IconButton
                dataHcName={`${dataHcName}-dismiss`}
                onClick={() => setIsOutdatedAck(true)}
                aria-label="Dismiss notification"
                icon={<CloseIcon />}
              />
            </Flex>
          ),
          duration: null, // Keep the toast open until user interacts
        }}
        closeToast={() => setIsOutdatedAck(true)}
      />
    );
  }

  return null; // Render nothing if up to date
};
